import React from 'react';
import "./modalGeneric.scss";
import Button from "../button/button";

const ModalGeneric = ({ isOpen, onClose, redirect, title, subtitle, cardContent }) => {

    if (!isOpen) {
        return null;
    }

    return (
        <div className="modal">
            <div className="modal-content">
            <div className="close-button" onClick={onClose}>x</div>
            <div className="contentModal">
                <h2>{title}</h2>
                <h3>{subtitle}</h3>
                <div className="contentProfessional">
                    {cardContent}
                </div>
                <Button
                    type="button"
                    text="Finalizar"
                    classname={`secondary`}
                    isDisabled={false}
                    onClickAction={redirect}
                />
                </div>
            </div>
        </div>
    );
};

export default ModalGeneric;
